import { useContext, useEffect, useState } from "react";
import { LogInUserID, typewatch, CamelCaseWithSpaces, transformNameOfCol, getTypeWatchDelay } from "../../JS/Common";
import { ApiGetCall, ApiGetCallAuthKey, ApiGetHeaders, ApiPostCall, ApiPostCallAuthKey } from "../../JS/Connector";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faArrowRightToBracket } from "@fortawesome/free-solid-svg-icons";
import AlertsComp from "../../Components/AlertsComp";
import Pagination from "react-js-pagination";
import { MDBSwitch } from "mdb-react-ui-kit";
import CustomizationPopup from "../../Components/CustomizationPopup";
import React from "react";
import PageHead from "../../Components/PageHead";
import Tab from "../../Components/Tab";
import AlertPopup from "../../Components/AlertPopup";
import { useNavigate } from "react-router-dom";
import { ThemeContext, UserContext } from "../../App";
import { setAdminSchoolId, setCsvUserID, setDefaultTicketStatus, setSchoolContactID, setSchoolId, setSchoolname, setSchoolnumber, setSelectedSchoolTimeZone } from "../../Store/Slices/authSlice";
import { useDispatch } from "react-redux";
import { hasRoleAccess, RoleEnum } from "../../JS/RoleType";
import useConfig from "../../Hooks/useConfig";
import Popup from "../../Components/Popup";
import AdminTokenGeneration from "../Admin/AdminTokenGeneration";
import { log } from "../../JS/Logger";
import { useStickyAction } from "../../Hooks";

export function IndexSchools() {
    const { organization, school, show_import_export_nav_btn, secondary_text, adminCallNode, school_tab } = useConfig();
    const [isDropdownOpen, setIsDropdownOpen] = useState(null);
    const [isDropdownShippingType, setisDropdownShippingType] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedShippingItem, setselectedShippingItem] = useState(null);
    const [AllSchoolsData, setAllSchoolsData] = useState([]);
    const [schooltabs, setschooltabs] = useState({
        k12customers: "active",
        other: "",
        enterprise_customer: '',
    });
    const [Locations, setLocations] = useState([]);
    const [Alerts, setAlerts] = useState("");
    const [AdminData, setAdminData] = useState({
        useremail: "",
        Schoolname: "",
        schoolid: "",
        Location: "",
        ShippingType: "",
        contactID: ""
    })
    const [Searchstring, setSearchstring] = useState(null)
    const [SortbyFlag, setSortbyFlag] = useState('asc')
    const [SortbyKey, setSortbyKey] = useState(null)
    const [isStatusPopup, setisStatusPopup] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const showPagination = AllSchoolsData.length > 0;
    const [loading, setLoading] = useState(false);
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [WarningPopup, setWarningPopup] = useState(false);
    const { UserData } = useContext(UserContext);
    const [userSchoolData, setUserSchoolData] = useState([])
    const [warningData, setWarningData] = useState({
        schoolid: '',
        oldestUserid: '',
        schoolname: '',
        selectedtimezone: '',
        defaultTicketStatus: null
    });
    const [noteVisibility, setNoteVisibility] = useState({});
    const navigate = useNavigate();
    const { dispatch } = useContext(ThemeContext);
    const reduxDispatch = useDispatch();

    const effectiveRole = UserData.copyrole || UserData.role || null;
    const excludeVar = hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_VAR);
    const onlyTechs = hasRoleAccess(effectiveRole, RoleEnum.ONLY_TECH);
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    useEffect(() => {
        ApiGetHeaders(42, setColumnNames)
        ApiGetCall(`${adminCallNode}/locations/all`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.length != 0) {
                    const sortedLocations = responseRs?.filter(item => item?.name != null && item?.name != "").sort((a, b) =>
                        a.name.localeCompare(b.name)
                    );
                    setLocations(sortedLocations);
                }
            }
        });
    }, []);
    useEffect(() => {
        getAllSchools(SortbyKey, Searchstring, SortbyFlag);
    }, [currentPage, LimitForPagination, schooltabs]);

    async function getSearchFlag(Searchstring) {
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`${adminCallNode}/billing/schools/search?search=${Searchstring}&userId=${LogInUserID}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    if (responseRs?.common_grid == 1) {
                        setschooltabs({ ...schooltabs, k12customers: "active", other: "", enterprise_customer: '' });
                    } else if (responseRs?.common_grid == 2) {
                        setschooltabs({ ...schooltabs, k12customers: "", other: "", enterprise_customer: 'active' });
                    } else if (responseRs?.common_grid == 3) {
                        setschooltabs({ ...schooltabs, k12customers: "", other: "active", enterprise_customer: '' });
                    } else {
                        setschooltabs({ ...schooltabs, k12customers: "active", other: "", enterprise_customer: '' });
                    }
                }
            });
        }, getTypeWatchDelay(Searchstring, 500));
    }

    async function getAllSchools(sortbykey, search, sortbyflag) {
        if (!search) {
            search = null
        } else {
            search = search?.trim();
        };
        if (sortbykey) {
            setSortbyKey(sortbykey)
            setSortbyFlag(sortbyflag);
        };
        var tabflag = null;
        schooltabs.k12customers == "active" ? tabflag = 24 : schooltabs.other == "active" ? tabflag = 25 : tabflag = 46;
        typewatch(async function () {
            setLoading(true);
            var url = null;
            if (tabflag == 24 || tabflag == 25) {
                url = `${adminCallNode}/billing/schools/all?search=${search}&userId=${LogInUserID}&sortBy=${sortbykey}&sortByOrder=${sortbyflag}&gridId=${tabflag}&page=${currentPage}&limit=${LimitForPagination}`;
            } else {
                url = `${adminCallNode}/billing/express-tech-schools/all?search=${search}&userId=${LogInUserID}&sortBy=${sortbykey}&sortByOrder=${sortbyflag}&gridId=${tabflag}&page=${currentPage}&limit=${LimitForPagination}`;
            }
            await ApiGetCall(url).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs.total)
                    setAllSchoolsData(responseRs?.data)
                    setLoading(false);
                }
            });
        }, 0);
    }
    function viewTickets(email, id, schoolname, contactID) {
        setAdminData({ ...AdminData, useremail: email, schoolid: id, flag: 1, Schoolname: schoolname, contactID: contactID });
        LoginIntoSchool(contactID);
    }
    async function LoginIntoSchool(contactID) {
        setLoading(true);
        var raw = JSON.stringify({
            loginUserId: LogInUserID,
            schoolAdminId: contactID,
            flag: 1,
        });
        await ApiPostCallAuthKey(`${adminCallNode}/technicians/set-school-login`, raw).then((result) => {
            setLoading(false);
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                var sugData = responseRs.k12data;
                if (responseRs.status == "success") {
                    reduxDispatch(setCsvUserID(sugData.id));
                    reduxDispatch(setSchoolId(responseRs.schooldata.school_id));
                    dispatch({ type: "UPDATE", payload: { ShippingType: responseRs?.schooldata?.school?.shipping_type }, });
                    if (responseRs.schooldata.school != null) {
                        reduxDispatch(setSchoolnumber(responseRs.schooldata.school.school_number));
                    } else {
                        reduxDispatch(setSchoolnumber(''));
                    }
                    window.location.href = '/manage-tickets';
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.status} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }

            }
        });
    }
    function handleArrowClick(ticketId) {
        setNoteVisibility((prevState) => ({
            ...prevState,
            [ticketId]: !prevState[ticketId],
        }));
    }
    async function UpdateLocation(Location, schoolid, shippingtype) {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: schoolid,
            locationId: Location == "0" ? null : Location,
            shppingType: Location == "0" ? 1 : shippingtype
        });
        await ApiPostCall(`${adminCallNode}/billing/schools/update`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Location Updated Successfully."} />);
                    getAllSchools(SortbyKey, Searchstring, SortbyFlag);
                    setIsDropdownOpen(null);
                    setisDropdownShippingType(null);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    function showSchoolTicket(schoolId, contactID, schoolname, selectTimeZone, DefaultTicketStatus) {
        const expires = 1;
        reduxDispatch(setAdminSchoolId(schoolId));
        reduxDispatch(setSchoolContactID(contactID));
        reduxDispatch(setSchoolname(schoolname));
        reduxDispatch(setSelectedSchoolTimeZone(selectTimeZone));
        reduxDispatch(setDefaultTicketStatus(DefaultTicketStatus));
        navigate('/school-tickets');
    }
    async function ActiveDeactive(id, flag) {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: id,
            flag: flag
        });
        await ApiPostCall(`${adminCallNode}/schools/status-change`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    var msg = flag == 1 ? `${organization} Activated Successfully` : `${organization} Deactivated Successfully`;
                    setAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                        getAllSchools(SortbyKey, Searchstring, SortbyFlag);
                    }, 2000);
                }
                else {
                    const responseRs = JSON.parse(result);
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs?.message} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                        getAllSchools(SortbyKey, Searchstring, SortbyFlag);
                    }, 3000);
                }
            }
        });
    }
    const handleSortClick = (item) => {
        if (item == 'schoolName') {
            item = 'name';
        } else if (item == 'openTickets') {
            item = 'openTicketCount';
        } else if (item == 'closeTickets') {
            item = 'closedTicketCount';
        } else if (item == 'totalTickets') {
            item = 'allTicketCount';
        }
        if (item !== 0) {
            setSortbyKey((prevSortbyKey) => {
                setSortbyFlag((prevSortbyFlag) => {
                    const newSortbyFlag = prevSortbyFlag === "asc" ? "desc" : "asc";
                    getAllSchools(item, Searchstring, newSortbyFlag);
                    return newSortbyFlag;
                });
                return item;
            });
        }
    };
    const handleSelectItem = (item, i) => {
        setSelectedItem(item);
        setIsDropdownOpen(i)
    };
    const handleSelectShippingItem = (item, i) => {
        setselectedShippingItem(item);
        setisDropdownShippingType(i)
    };
    function renderContentForColumn(columnName, item, i) {
        const contentMap = {
            "schoolName": (item.name && item.state_or_province_code)
                ? `${item.name} ${item.state_or_province_code == 0 ? "-" : `(${item.state_or_province_code})`}`
                : item?.name ?? '-',
            "locationName": (
                excludeVar ?
                    <div schoolid={item.id} className={`col-md-12 grid-item ${selectedItem == item ? 'selected' : ''}`}
                        onClick={() => handleSelectItem(item, i)}
                        onMouseLeave={(e) => {
                            const related = e.relatedTarget;

                            // Only check contains() when related is a Node
                            if (
                                !related ||
                                !(related instanceof Node) ||
                                !e.currentTarget.contains(related) ||
                                related.tagName?.toLowerCase() !== "select"
                            ) {
                                setIsDropdownOpen(null);
                            }
                        }}
                    >
                        {isDropdownOpen == i ?
                            <select value={item?.location_id} onChange={(e) => { setAdminData({ ...AdminData, Location: e.target.value }); UpdateLocation(e.target.value, item.id, item.shipping_type); }}  >
                                <option value="0">Select</option>
                                {Locations.map((locationItem, j) => (
                                    <option value={locationItem.id} key={j} defaultValue={locationItem.id == item?.location_id} >
                                        {locationItem.name}
                                    </option>
                                ))}
                            </select>
                            : item?.location_id == null || item?.location_id == 0 ?
                                (<div>-</div>)
                                :
                                (<div className="cursor-pointer">{item?.location_name}</div>)
                        }
                    </div>
                    :
                    item?.location_id == null || item?.location_id == 0 ?
                        (<div>-</div>)
                        :
                        (<div>{item?.location_name}</div>)

            ),
            "shippingType": (
                excludeVar ?
                    <div schoolid={item.id} className={`col-md-12 grid-item ${selectedShippingItem === item ? 'selected' : ''}`}
                        onClick={() => handleSelectShippingItem(item, i)}
                        onMouseLeave={(e) => {
                            const related = e.relatedTarget;

                            // Only check contains() when related is a Node
                            if (
                                !related ||
                                !(related instanceof Node) ||
                                !e.currentTarget.contains(related) ||
                                related.tagName?.toLowerCase() !== "select"
                            ) {
                                setisDropdownShippingType(null);
                            }
                        }}

                    >
                        {isDropdownShippingType === i ?
                            <select value={item.shipping_type}
                                onChange={(e) => { setAdminData({ ...AdminData, ShippingType: e.target.value }); UpdateLocation(item.location_id, item.id, e.target.value); }}>
                                <option value="0">Select</option>
                                <option value="1">Local</option>
                                <option value="2">Mail In</option>
                            </select>
                            :
                            <div className="cursor-pointer">{item.shipping_type == "1" ? "Local" : item.shipping_type == "0" ? "Select" : "Mail In"}</div>
                        }
                    </div>
                    : AdminData.ShippingType == "1" ? 'Local' : 'Mail In'

            ),
            "totalTickets": item.all_ticket_count || "0",
            "closeTickets": item.closed_ticket_count || "0",
            "contactEmail": item.oldestuser_email || "-",
            "contactName": item?.oldestuser_name || "-",
            "openTickets": item.open_ticket_count || '0'
        };

        return contentMap[columnName] || null;
    }
    function handleSearchChange(e) {
        setCurrentPage(1);
        setSearchstring((prevSearchstring) => {
            const newSearchstring = e.target.value;
            if (newSearchstring) {
                getSearchFlag(newSearchstring);
            } else {
                getAllSchools(SortbyKey, newSearchstring, SortbyFlag)
            }
            return newSearchstring;
        });
    }
    function handleTabClick(tabType) {
        if (tabType == "k12") {
            setCurrentPage(1);
            setschooltabs({ ...schooltabs, k12customers: "active", other: "", enterprise_customer: '' });
            setIsDropdownOpen(null);
            setisDropdownShippingType(null);
            setNoteVisibility({});
        } else if (tabType == "other") {
            setCurrentPage(1);
            setschooltabs({ ...schooltabs, k12customers: "", other: "active", enterprise_customer: '' });
            setIsDropdownOpen(null);
            setisDropdownShippingType(null);
            setNoteVisibility({});
        } else if (tabType == "enterprise_customer") {
            setCurrentPage(1);
            setschooltabs({ ...schooltabs, k12customers: "", other: "", enterprise_customer: 'active' });
            setIsDropdownOpen(null);
            setisDropdownShippingType(null);
            setNoteVisibility({});
        }
    }

    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Accounts"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            <div className="GridBox mt-2 p-3">
                <div className="row">
                    <div className="col-md-9 pe-0 pb-3">
                        {excludeVar &&
                            <ul className="nav nav-tabs">
                                <Tab isActive={schooltabs.k12customers == 'active'}
                                    label={`${school_tab}`} onClick={() => handleTabClick('k12')} />
                                <Tab isActive={schooltabs.enterprise_customer == 'active'}
                                    label={`Business Customers`} onClick={() => handleTabClick('enterprise_customer')} />
                                <Tab isActive={schooltabs.other == 'active'}
                                    label={`Other ${secondary_text} Users`} onClick={() => handleTabClick('other')} />
                            </ul>
                        }
                        {hasRoleAccess(effectiveRole, RoleEnum.ONLY_VAR) &&
                            <ul className="nav nav-tabs d-none">
                                <Tab isActive={schooltabs.k12customers == 'active'}
                                    label={`${organization} Customers`} onClick={() => handleTabClick('k12')} />
                            </ul>
                        }
                    </div>
                    <div className="col-md-3 text-end">
                        <div className="row">
                            <div className="col-12">
                                {show_import_export_nav_btn && !hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_TECH_VAR) &&
                                    <label className='BorderBtn me-1 text-center' title="Export Service Profile" onClick={() => navigate('/import-export')}>
                                        <img src='/images/ExportInventory.svg' className='img-fluid pe-2' />Export Service Profile
                                    </label>
                                }
                            </div>
                        </div>

                    </div>
                </div>
                <div className="greyBox p-3">
                    <div className="data-table-container" ref={tableWrapperRef}>
                        {onlyTechs ?
                            <div className="col-12 py-1">
                                <label className="blueText">*{organization}s are assigned to your location</label>
                            </div> : null
                        }
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    {columnNames?.map((item) => {
                                        const columnName = item.replace(/_/g, ' ');
                                        const transformedName = transformNameOfCol(columnName);
                                        if (!transformedName) return null;
                                        return columnName != 'contactEmail' && columnName != 'contactName' && columnName != 'shippingType' ?
                                            <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                {CamelCaseWithSpaces(transformedName)}
                                                <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                            </th>
                                            :
                                            <th key={item} scope="col" className='fw-600'>
                                                {CamelCaseWithSpaces(transformedName)}
                                            </th>
                                    })}
                                    <th scope="col" className='fw-600 '>Active</th>
                                    <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action text-center' : ''}`} >Action
                                        <img src="/images/EditHeaderIcon.svg" className="cursor-pointer  img-fluid ps-2 pe-5"
                                            title='Customize Headers' style={{ height: '25px' }}
                                            onClick={(e) => setCustomizationModal(true)} />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {AllSchoolsData?.length != 0 ?
                                    AllSchoolsData?.map((item, i) => {
                                        const isNoteVisible = noteVisibility[item.id];
                                        return (
                                            <>
                                                <tr key={i} className={`OddEvenClass tableBorderHide ${item.location_assign_flag == 1 && 'blueText'}`}>
                                                    {columnNames?.map((header, k) => (
                                                        <td scope="col" className="py-12" key={k}>
                                                            {renderContentForColumn(header, item, i)}
                                                        </td>
                                                    ))}
                                                    <td scope="col" className='py-4 py-12'>
                                                        {item.status == 1 ?
                                                            <MDBSwitch className="BgPink cursor-pointer" checked={item?.isChecked || true} onChange={(e) => { ActiveDeactive(item.id, 2) }} />
                                                            :
                                                            <MDBSwitch className="BgPink cursor-pointer" checked={item?.isChecked || false} onChange={(e) => { ActiveDeactive(item.id, 1) }} />
                                                        }
                                                    </td>
                                                    <td className={`text-center d-flex align-items-center py-4 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                        <span title={`Login as ${school} Admin`}>
                                                            <FontAwesomeIcon icon={faArrowRightToBracket} style={{ color: "black" }}
                                                                title={`Login as ${school} Admin`} className='parent-icon cursor-pointer '
                                                                onClick={() => {
                                                                    viewTickets(item?.oldestuser_email, item?.id, item.name, item?.oldestuser_id);
                                                                }} />
                                                        </span>
                                                        <img src="/images/eye.png" className="ps-2 cursor-pointer " title={`Show ${organization} Tickets`}
                                                            onClick={(e) => {
                                                                setWarningData({ ...warningData, schoolid: item.id, oldestUserid: item?.oldestuser_id, schoolname: item.name, selectedtimezone: item?.timezone_name, defaultTicketStatus: item?.default_ticket_status });
                                                                onlyTechs ?
                                                                    item.location_assign_flag != 1 ? setWarningPopup(true) :
                                                                        showSchoolTicket(item.id, item?.oldestuser_id, item.name, item?.timezone_name, item?.default_ticket_status)
                                                                    :
                                                                    showSchoolTicket(item.id, item?.oldestuser_id, item.name, item?.timezone_name, item?.default_ticket_status)
                                                            }} />
                                                        {hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_REPAIR_VAR) ?
                                                            <span title="Service Profile">
                                                                <FontAwesomeIcon icon={faAddressCard} style={{ color: "black" }} title="Service Profile" className='ps-2 parent-icon cursor-pointer '
                                                                    onClick={() => navigate('/school-profile', { state: { schoolid: item.id, schoolname: item.name, flag: 2 } })} />
                                                            </span>
                                                            : null
                                                        }
                                                        <img src="/images/DownRoundArrow.svg" title="Show More Details" height={22} width={22} className={`ps-2 cursor-pointer img-fluid ${isNoteVisible ? "d-none" : ""}`} onClick={() => handleArrowClick(item.id)} />
                                                        <img src="/images/UpRoundArrow.svg" title="Hide More Details" height={22} width={22} className={`ps-2 img-fluid cursor-pointer ${isNoteVisible ? "" : "d-none"}`} onClick={() => handleArrowClick(item.id)} />
                                                    </td>
                                                </tr>
                                                {isNoteVisible && (
                                                    <>
                                                        <tr className={`col-12  px-5`}>
                                                            <td colSpan={18}>
                                                                <b className="font-13 pe-3"> Allowed Domains:</b>
                                                                <div style={{ display: "inline" }}> {item?.domain?.replaceAll(",", ", ") || '-'} </div>
                                                            </td>
                                                        </tr>
                                                        <tr className={`col-12  px-5`}>
                                                            <td colSpan={18}>
                                                                <b className="font-13 pe-3">City:</b>
                                                                <div style={{ display: "inline" }}> {item.city || '-'} </div>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )}
                                            </>
                                        )
                                    })
                                    :
                                    <tr>
                                        <td colSpan={18} className="p-3 text-center">
                                            No Record Found
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    {showPagination && (
                        <Pagination
                            activePage={currentPage}
                            totalItemsCount={pageRangeCount}
                            pageRangeDisplayed={15}
                            itemsCountPerPage={LimitForPagination}
                            onChange={(e) => { setCurrentPage(e); setSortbyFlag(SortbyFlag) }}
                            color="primary"
                            lastPageText=""
                            firstPageText=""
                            itemClassFirst="MasterClass"
                            itemClassPrev="MasterClass"
                            itemClassNext="MasterClass"
                            itemClassLast="MasterClass"
                            hideFirstLastPages={true}
                        />
                    )}
                </div>
            </div>
            <AlertPopup isshow={isStatusPopup} img={'/images/greenInfo.svg'}
                headingtext={`Login as ${organization} Admin`} text={`Are you sure want to login as ${AdminData.Schoolname}?`}
                cancelcall={(e) => setisStatusPopup(false)}
                canceltext={"No"} successtext={"Continue"} successcall={LoginIntoSchool} btntype={'SaveBtn'} />


            <AlertPopup isshow={WarningPopup} img={'/images/greenInfo.svg'}
                headingtext={''} text={`You have just selected a ${school} that does not belong to the location you are assigned to. Double check the ${school} name and verify you selected the right account. Proceed?`}
                cancelcall={(e) => setWarningPopup(false)}
                canceltext={"No"} successtext={"Yes"} successcall={(e) => showSchoolTicket(warningData.schoolid,
                    warningData.oldestUserid, warningData.schoolname, warningData.selectedtimezone, warningData.defaultTicketStatus)} btntype={'SaveBtn'} />

            {CustomizationModal && <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={`${organization}s`} GetCall={() => ApiGetHeaders(42, setColumnNames)} />}
        </React.Fragment>
    )
}
